import React from 'react';
import { Link } from 'react-router-dom';
import constants from '../ndbk-constants'
import * as d3 from "./d3.modified.js"
import Utils from './Utils'

class AddNewNodebook extends React.Component {
    componentDidMount() {
        d3.select(this.wrapper)
            .style('opacity', 0)
            .transition()
                .duration(500)
                .style('opacity', 1)
    }

    render() {
        return (
            <div onClick={this.props.createNodebook} className="col-lg-4 col-md-6 col-sm-12">
                    <div className="nodebook-preview" ref={c=>this.wrapper=c}>
                        <h1 className="center">+ Add new</h1>
                    </div>
            </div>
        )
    }
}

export default class PreviewNodebook extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            info: this.props.info
        }

        if (!this.state.info) {
            fetch(`https://${constants.SERVER_IP}/api/nodebook/${this.props.nodatasohereisid}/preview`, {
                credentials: 'include',
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.success) {
                        this.setState({info: response.data})
                    }
                    return response.success;
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    componentDidMount() {
        d3.select(this.wrapper)
            .style('opacity', 0)
            .transition()
                .duration(500)
                .style('opacity', 1)
    }

    render() {

        let query = this.props.query ? this.props.query : ''

        if (!this.state.info) {
            return null
        }

        var elapsed_str = Utils.parseTimeDiff(new Date(this.state.info.date_created))

        var content = (
            <div ref={c=>this.wrapper=c} xmlns={this.props.xmlns?'http://www.w3.org/1999/xhtml':undefined} className={/*this.props.xmlns?'':*/"nodebook-preview"+(this.props.nohover?' nohover':'')}>
                <div className="avatar" style={{backgroundImage: `url(${this.state.info.avatar})`}}></div>
                <h1>{this.state.info.title}
                    <small>{this.state.info.username || this.state.info.author_username} &middot; {elapsed_str} {this.state.info.visibility==='private'?<div className="visibility-private">private</div>:null}</small>
                    <small className="ccnt">{this.state.info.nodes} nodes &middot; {this.state.info.links} links</small>
                </h1>
                {/*
                    <p>Created: {this.state.info.date_created}</p>
                    <p>Modified: {this.state.info.date_modified}</p>
                */}

                {/*<p>{this.state.info.description}</p>*/}
                <div className="stats">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                            <path fill="#382371" d="M19.872 10.166c-0.047-0.053-1.182-1.305-2.956-2.572-1.047-0.748-2.1-1.344-3.13-1.773-1.305-0.544-2.579-0.82-3.786-0.82s-2.481 0.276-3.786 0.82c-1.030 0.429-2.083 1.026-3.13 1.773-1.774 1.267-2.909 2.52-2.956 2.572-0.171 0.19-0.171 0.479 0 0.669 0.047 0.053 1.182 1.305 2.956 2.572 1.047 0.748 2.1 1.344 3.13 1.773 1.305 0.544 2.579 0.82 3.786 0.82s2.481-0.276 3.786-0.82c1.030-0.429 2.083-1.026 3.13-1.773 1.774-1.267 2.909-2.52 2.956-2.572 0.171-0.19 0.171-0.479 0-0.669zM12.574 6.438c0.907 0.763 1.426 1.873 1.426 3.062 0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.188 0.519-2.299 1.426-3.062 0.822-0.268 1.691-0.438 2.574-0.438s1.752 0.17 2.574 0.438zM16.317 12.606c-1.533 1.092-3.873 2.394-6.317 2.394s-4.784-1.302-6.317-2.394c-1.157-0.824-2.042-1.658-2.489-2.106 0.447-0.448 1.332-1.281 2.489-2.106 0.53-0.378 1.156-0.78 1.85-1.145-0.347 0.688-0.533 1.455-0.533 2.251 0 2.757 2.243 5 5 5s5-2.243 5-5c0-0.796-0.186-1.563-0.533-2.251 0.694 0.365 1.32 0.768 1.85 1.145 1.157 0.824 2.042 1.658 2.489 2.106-0.447 0.448-1.332 1.281-2.489 2.106z"></path>
                            </svg>
                        {Utils.parseAmount(this.state.info.views)}
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                            <path fill="#382371" d="M1.5 19c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5z"></path>
                            <path fill="#382371" d="M3.5 10c-0.104 0-0.21-0.033-0.3-0.1-0.221-0.166-0.266-0.479-0.1-0.7 0.067-0.090 1.676-2.2 3.9-2.2 1.694 0 2.813 0.599 3.801 1.127 0.875 0.468 1.631 0.873 2.699 0.873 2.192 0 3.758-2.080 4.65-3.718-0.698 0.397-1.59 0.718-2.65 0.718-2.207 0-3.347-1.14-4.354-2.146-0.995-0.995-1.854-1.854-3.646-1.854-2.224 0-3.587 1.782-3.6 1.8-0.166 0.221-0.479 0.266-0.7 0.1s-0.266-0.479-0.1-0.7c0.067-0.090 1.681-2.2 4.4-2.2 2.207 0 3.347 1.14 4.354 2.146 0.995 0.995 1.854 1.854 3.646 1.854 2.224 0 3.587-1.782 3.6-1.8 0.147-0.196 0.415-0.257 0.632-0.143s0.32 0.368 0.242 0.601c-0.021 0.064-0.533 1.581-1.558 3.119-0.612 0.918-1.282 1.653-1.991 2.185-0.918 0.688-1.902 1.037-2.925 1.037-1.318 0-2.26-0.504-3.171-0.991-0.97-0.519-1.886-1.009-3.329-1.009-1.73 0-3.087 1.782-3.1 1.8-0.098 0.131-0.248 0.2-0.4 0.2z"></path>
                        </svg>
                        {Utils.parseAmount(this.state.info.followers)}
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                            <path fill="#382371" d="M18.916 11.208c0.443-0.511 0.695-1.355 0.695-2.159 0-0.531-0.115-0.996-0.333-1.345-0.284-0.454-0.738-0.704-1.278-0.704h-2.618c1.425-2.591 1.785-4.543 1.070-5.807-0.499-0.881-1.413-1.193-2.045-1.193-0.25 0-0.462 0.185-0.495 0.433-0.179 1.319-1.188 2.893-2.768 4.318-1.514 1.365-3.374 2.456-5.286 3.11-0.241-0.508-0.758-0.86-1.356-0.86h-3c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h3c0.634 0 1.176-0.395 1.396-0.952 1.961 0.246 2.699 0.64 3.414 1.022 0.895 0.478 1.739 0.93 4.503 0.93 0.72 0 1.398-0.188 1.91-0.529 0.5-0.333 0.82-0.801 0.926-1.343 0.399-0.162 0.753-0.536 1.024-1.092 0.264-0.541 0.435-1.232 0.435-1.761 0-0.099-0.006-0.19-0.017-0.274 0.253-0.186 0.48-0.473 0.667-0.851 0.27-0.545 0.432-1.228 0.432-1.826 0-0.424-0.079-0.777-0.234-1.051-0.013-0.022-0.026-0.044-0.039-0.065zM4.5 18h-3c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v8.999c0 0 0 0.001 0 0.001-0 0.276-0.224 0.5-0.5 0.5zM18.339 10.274c-0.151 0.304-0.304 0.414-0.37 0.414-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.042 0 0.072 0 0.117 0.078 0.066 0.117 0.104 0.32 0.104 0.558 0 0.445-0.126 0.974-0.328 1.382-0.198 0.399-0.399 0.544-0.487 0.544-0.276 0-0.5 0.224-0.5 0.5 0 0.177 0.092 0.333 0.231 0.422 0.031 0.317-0.117 1.165-0.501 1.718-0.145 0.209-0.298 0.329-0.418 0.329-0.276 0-0.5 0.224-0.5 0.5 0 0.88-0.972 1.281-1.875 1.281-2.513 0-3.217-0.376-4.032-0.812-0.762-0.407-1.618-0.865-3.781-1.134v-8.187c2.101-0.689 4.152-1.877 5.812-3.373 1.593-1.436 2.639-2.988 2.994-4.426 0.272 0.087 0.579 0.271 0.776 0.618 0.334 0.59 0.584 2.096-1.493 5.557-0.093 0.154-0.095 0.347-0.006 0.504s0.255 0.254 0.435 0.254h3.483c0.199 0 0.327 0.070 0.43 0.234 0.117 0.187 0.181 0.477 0.181 0.815 0 0.424-0.102 0.882-0.272 1.225z"></path>
                        </svg>
                        {Utils.parseAmount(this.state.info.likes)}
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                            <path fill="#382371" d="M17.5 5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                            <path fill="#382371" d="M17.5 8h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                            <path fill="#382371" d="M17.5 11h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                            <path fill="#382371" d="M17.5 14h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                            <path fill="#382371" d="M17.5 17h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h15c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                        </svg>
                        {Utils.parseAmount(this.state.info.comments)}
                    </div>
                </div>
            </div>
        )

        return (this.props.nowrap)
            ?   content
            :   <div className={this.props.fullSize?'col-lg-12':"col-lg-4 col-md-6 col-sm-12"} ref={c=>this.wrapper=c}>
                    <Link to={"/nodebook/" + this.state.info.id + query} title={this.state.info.title}>
                    {content}
                    </Link>
                </div>
    }
}

export {
    PreviewNodebook,
    AddNewNodebook
}



// WEBPACK FOOTER //
// ./src/components/PreviewNodebook.js